<template>
    <DsPageButton
        :border
        :disabled="disabled"
        :selected="selected"
    >
        <slot />
    </DsPageButton>
</template>

<script setup lang="ts">
import DsPageButton from './DsPageButton.vue';

export type IconButtonSize = 'md' | 'sm';

export interface DsIconButtonProps {
    selected?: boolean;
    disabled?: boolean;
    border?: boolean;
}

withDefaults(defineProps<DsIconButtonProps>(), {
    disabled: false,
    selected: false,
    border: true,
});
</script>
